import { render, staticRenderFns } from "./ReplacementForm.vue?vue&type=template&id=48b7b080&scoped=true&"
import script from "./ReplacementForm.vue?vue&type=script&lang=js&"
export * from "./ReplacementForm.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementForm.vue?vue&type=style&index=0&id=48b7b080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b7b080",
  null
  
)

export default component.exports